import GDKError from './GDKError';
export default class GDKValidationError extends GDKError {
    errors;
    constructor(original, lang, code, errors, response = null) {
        super(original, lang, code, response);
        this.name = 'GDKValidationError';
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        this.message = response?.message || original?.message || '';
        this.errors = errors;
    }
}
//# sourceMappingURL=GDKValidationError.js.map